import type { TechnicalBoardCall, TechnicalBoardTeamMember } from "./technical-board-model";

export const demoItems = (): TechnicalBoardCall[] => {
  const now = Date.now();
  const minutesAgo = (minutes: number) => new Date(now - minutes * 60_000).toISOString();
  return [
    {
      id: "demo-call-1",
      runId: "demo-run-1",
      lineId: "demo-line-1",
      lineCode: "AMB-02",
      lineName: "AMBALAJ 2",
      workOrderNo: "UE-260908-114",
      productName: "Çikolatalı Gofret 40 g",
      department: "ELECTRICAL",
      note: "Fotosel ürünü algılamıyor; hat yeniden başlatılamıyor.",
      operatorName: "Ayşe Yılmaz",
      createdAt: minutesAgo(9),
      status: "RECORDED",
      impact: "STOPPED",
      notificationState: "NOT_CONFIGURED",
      assignedTechnicianName: null,
      claimedAt: null,
      waitingReason: null,
      resolutionNote: null,
      resolvedAt: null,
      closedAt: null,
      version: 1,
    },
    {
      id: "demo-call-2",
      runId: "demo-run-2",
      lineId: "demo-line-2",
      lineCode: "BIS-01",
      lineName: "BİSKÜVİ 1",
      workOrderNo: "UE-260908-109",
      productName: "Kakaolu Bisküvi 100 g",
      department: "MECHANICAL",
      note: "Fırın çıkış konveyöründe düzensiz titreşim var.",
      operatorName: "Kemal Arslan",
      createdAt: minutesAgo(6),
      status: "IN_PROGRESS",
      impact: "DEGRADED",
      notificationState: "DELIVERED",
      assignedTechnicianName: "Murat Demir",
      claimedAt: minutesAgo(4),
      waitingReason: null,
      resolutionNote: null,
      resolvedAt: null,
      closedAt: null,
      version: 2,
    },
    {
      id: "demo-call-3",
      runId: "demo-run-3",
      lineId: "demo-line-3",
      lineCode: "AMB-05",
      lineName: "AMBALAJ 5",
      workOrderNo: "UE-260908-118",
      productName: "Fındıklı Bar 35 g",
      department: "MECHANICAL",
      note: "Çene mekanizması sıkışıyor; koruma devreye giriyor.",
      operatorName: "Sibel Kaya",
      createdAt: minutesAgo(23),
      status: "IN_PROGRESS",
      impact: "STOPPED",
      notificationState: "DELIVERED",
      assignedTechnicianName: "Emre Akın",
      claimedAt: minutesAgo(20),
      waitingReason: null,
      resolutionNote: null,
      resolvedAt: null,
      closedAt: null,
      version: 2,
    },
    {
      id: "demo-call-4",
      runId: "demo-run-4",
      lineId: "demo-line-4",
      lineCode: "PAK-03",
      lineName: "PAKETLEME 3",
      workOrderNo: "UE-260908-102",
      productName: "Sütlü Tablet 60 g",
      department: "ELECTRICAL",
      note: "Bant motorunda aşırı akım uyarısı alındı.",
      operatorName: "Can Öztürk",
      createdAt: minutesAgo(41),
      status: "WAITING",
      impact: "STOPPED",
      notificationState: "DELIVERED",
      assignedTechnicianName: "Selin Yıldız",
      claimedAt: minutesAgo(39),
      waitingReason: "Yedek motor ve elektrik izolasyon izni bekleniyor.",
      resolutionNote: null,
      resolvedAt: null,
      closedAt: null,
      version: 3,
    },
    {
      id: "demo-call-5",
      runId: "demo-run-5",
      lineId: "demo-line-5",
      lineCode: "AMB-01",
      lineName: "AMBALAJ 1",
      workOrderNo: "UE-260908-106",
      productName: "Bitter Tablet 80 g",
      department: "ELECTRICAL",
      note: "Tarih kodlama sensörü yeniden kalibre edildi.",
      operatorName: "Elif Şahin",
      createdAt: minutesAgo(18),
      status: "RESOLVED_PENDING_CONFIRMATION",
      impact: "RUNNING",
      notificationState: "DELIVERED",
      assignedTechnicianName: "Onur Çetin",
      claimedAt: minutesAgo(16),
      waitingReason: null,
      resolutionNote: "Tarih kodlama sensörü yeniden kalibre edildi.",
      resolvedAt: minutesAgo(2),
      closedAt: null,
      version: 3,
    },
  ];
};

export const demoTeam: TechnicalBoardTeamMember[] = [
  { id: "demo-tech-1", name: "Selin Yıldız", department: "ELECTRICAL", status: "IN_PROGRESS", currentLineName: "PAKETLEME 3" },
  { id: "demo-tech-2", name: "Onur Çetin", department: "ELECTRICAL", status: "AVAILABLE", currentLineName: null },
  { id: "demo-tech-3", name: "Emre Akın", department: "MECHANICAL", status: "IN_PROGRESS", currentLineName: "AMBALAJ 5" },
  { id: "demo-tech-4", name: "Murat Demir", department: "MECHANICAL", status: "IN_PROGRESS", currentLineName: "BİSKÜVİ 1" },
];
